export const isUrlPatterMatchOrNot = (path: string, pattern: RegExp) => {
  return path.match(pattern);
};
